/**
 * `mcp` namespace — the "AI clients (MCP)" Access Hub tab (ADR 0788 D6).
 */
export const messages = {
  loading: 'Loading AI client access…',
  signedOutTitle: 'Sign in to connect an AI client',
  signedOutBody: 'AI clients act as you, so connecting one needs a signed-in account.',
  forbiddenTitle: 'You can’t view AI client access here',
  forbiddenBody: 'Ask a workspace admin for access to this workspace.',
  loadFailedTitle: 'AI client access didn’t load',
  retry: 'Try again',

  endpointTitle: 'Server address',
  mountOff: 'This deployment doesn’t accept AI client connections yet. The server administrator can turn it on; nothing in this workspace needs to change first.',
  endpointHelp: 'Add this address as a remote MCP server in your AI client.',
  urlCopied: 'Server address copied',
  copyUrl: 'Copy the server address',
  copy: 'Copy',
  protocols: 'Protocol versions: {{versions}}',
  viaProxy: 'This address goes through the web app’s proxy, which can cut off tools that run for more than a minute. The server administrator can publish a direct address.',

  keysTitle: 'Keys for AI clients',
  keysHelp: 'Each AI client signs in with its own key. A key acts as you, limited to what you choose here. Revoke it here if a client is lost or no longer used.',
  keyLabel: 'Name this key',
  keyLabelPlaceholder: 'e.g. Laptop — Cursor',
  presetLegend: 'What can the client do?',
  presetRead: 'Read only',
  presetReadHelp: 'Search and read with the built-in read tools. Nothing changes in the workspace.',
  presetAct: 'Read & act',
  presetActHelp: 'Also run tools that change things, and this workspace’s own tools. Tools that ask for approval still ask.',
  createKey: 'Create key',
  keyCreated: 'Key “{{name}}” created',
  issuedRegion: 'Your new key',
  issuedOnce: 'Copy the configuration for “{{name}}” now. The key is shown only once; if you lose it, revoke it and create another.',
  snippetLabel: 'Client configuration with your key',
  copyConfig: 'Copy configuration',
  configCopied: 'Configuration copied',
  done: 'Done',
  snippetCaveat: 'This is the usual shape for clients that support remote servers with a bearer header. Your client’s settings may name the fields differently.',
  yourKeys: 'Active keys',
  noKeys: 'No keys yet. Create one above for each AI client you use.',
  createdOn: 'Created {{date}}',
  lastUsed: 'last used {{date}}',
  neverUsed: 'never used',
  revoke: 'Revoke',
  revokeNamed: 'Revoke key {{name}}',
  revokeConfirmTitle: 'Revoke “{{name}}”?',
  revokeConfirmBody: 'Any AI client using this key stops working immediately. This can’t be undone.',
  keyRevoked: 'Key “{{name}}” revoked',
  keysAdminNote: 'Workspace admins see every AI client key in the workspace here.',

  toolsTitle: 'Tools AI clients can use',
  toolsHelp: 'What an AI client signed in as you can call. A read-only key sees fewer.',
  toolsHelpAdmin: 'What an AI client signed in as you can call. Turning a tool off here turns it off for every client in this workspace.',
  noToolsTitle: 'No tools available to AI clients',
  noToolsBody: 'Tools appear here when a feature that offers them is on for this workspace, or when a workflow in this workspace exposes one.',
  sourceHost: 'Built-in',
  sourceWorkspace: 'This workspace',
  tierRead: 'Reads',
  tierWrite: 'Makes changes',
  asksApproval: 'Asks for approval',
  turnedOff: 'Turned off',
  on: 'On',
  off: 'Off',
  switchLabel: 'Let AI clients use {{name}}',
  toolTurnedOn: '{{name}} is available to AI clients',
  toolTurnedOff: '{{name}} is turned off for AI clients',
  needs: 'Needs: {{scopes}}',
  scopeRead: 'Read the workspace',
  scopeWrite: 'Change the workspace',
  scopeRun: 'Run workflows',
  keyLabelRequired: 'Give the key a name so you can tell your clients apart.',
  presetActUnavailable: 'Needs edit access to this workspace. Ask an admin if you need it.',
  keyNotYours: 'Someone else’s',
  mayAskApproval: 'May ask for approval',
  toolsHelpMountOff: 'When this deployment accepts AI clients, a client signed in as you will be able to use these.',
} as const;
